import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import Section from "core/components/Section";
import RecipeInfo from "./../components/RecipeInfo";
import RecipeIngredients from "./../components/RecipeIngredients/index";
import HowToCook from "./../components/HowToCook/index";
import VideoList from "./../components/VideoList/index";
import { useRecipeDetail } from "./../hooks/recipe";
import { useRecipe as useRecipeSelecting } from "modules/Ingredients/hooks/recipe";
import { useParams } from "react-router-dom";
import { useGetListCart } from "modules/Carts/hooks";
import { useState } from "react";
import LoadingAI from "modules/AiChef/components/Loading";
import CoupangAds from "core/components/Coupang/CoupangAds";
import IngredientCoupang from "../components/IngredientCoupang";
import RecipeCoupang from "../components/RecipeCoupang";

type TRecipeDetailPage = {
  activeIndex: 1 | 2 | 3 | 4 | 5;
};

const RecipeDetailPage = ({ activeIndex = 2 }: TRecipeDetailPage) => {
  useScrollToTop();
  const { id } = useParams();
  const { data, loading, reload, recipeRequestId } = useRecipeDetail(id);
  const { resetRecipes } = useRecipeSelecting();
  const [paramCart] = useState<any>({
    order_by: "id",
    order_dir: "desc",
    page: 1,
    page_size: 1000,
  });
  useGetListCart(paramCart);
  const pd = (window as any)._APP_LANG === "ko" ? '!pb-[140px]' : 'pb-[70px]';
  
  const ingredientsArrayName = data?.content?.ingredient?.map((item: any) => item.name) ?? [];
  const _ingredientsArrayName = ingredientsArrayName.slice(0, 4);
  
  const recipeArrayName = data?.name ? [data?.name] : [];
  
  return (
    <AppLayout className={` ${pd}`}>
      <PageHeader title={_t("recipe.title_detail")} sticky />
      <div>
        {loading ? <LoadingAI /> : null}
        <Section className="px-4 py-[30px] border-[#f4f4f4]">
          <RecipeInfo
            recipe={data}
            loading={false}
            reload={reload}
            recipeRequestId={recipeRequestId}
          />
        </Section>
        <Section className="px-4 py-[30px] border-[#f4f4f4]">
          <RecipeIngredients recipe={data} loading={false} />
        </Section>

        {(window as any)._APP_LANG === "ko" && (
          <Section className="py-[10px] border-[#f4f4f4]">
            <IngredientCoupang title="재료 관련제품" keyword={_ingredientsArrayName || []}/>
          </Section>
        )}

        <Section className="px-4 py-[30px] border-[#f4f4f4]">
          <HowToCook recipe={data} loading={false} />
        </Section>

        {(window as any)._APP_LANG === "ko" && (
          <Section className="py-[10px] border-[#f4f4f4]">
            <RecipeCoupang title="레시피 관련제품" keyword={recipeArrayName}/>
          </Section>
        )}
        <Section className="pt-[30px]">
          <VideoList videos={data?.youtube_videos} loading={false} />
        </Section>
      </div>
      <CoupangAds />
      <BottomNavigation
        onNavigateChange={resetRecipes}
        activeIndex={activeIndex}
      />
    </AppLayout>
  );
};

export default RecipeDetailPage;
